import Box from "@mui/material/Box";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import React from "react";
import { Alert } from "$components";

export const TableRowError = ({ op, idx }: any) => {
  return (
    <React.Fragment key={`row-${idx}`}>
      <TableRow style={{ opacity: 0.5, pointerEvents: "none" }}>
        <TableCell colSpan={1}>
          <Box>
            <p>{op?.code}</p>
            <Alert severity="error">Information EDB manquante</Alert>
          </Box>
        </TableCell>
        <TableCell colSpan={1}>
          <Box>
            <p>{op?.dockyard?.code}</p>
          </Box>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
